export default __webpack_public_path__ + "static/media/sale2.107b71b6.webp";